import { useCallback } from 'react';

export function useFullscreen(): () => void {
  return useCallback(() => {
    try {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch(() => {});
      } else {
        document.exitFullscreen().catch(() => {});
      }
    } catch {
      /* noop */
    }
  }, []);
}
